import { usersApi } from 'entities/users';
import { toast } from 'react-toastify';

const useStories = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getStories: builder.query({
      query: ({ page, size }) => ({ url: '/news-pages/admin/story', params: { page, size } }),
    }),

    getStory: builder.query({
      query: ({ id }) => ({ url: `/news-pages/admin/story/${id}` }),
    }),

    addStory: builder.mutation({
      query: ({ body }) => ({
        url: '/news-pages/admin/story',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили историю', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }

        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),

    editStory: builder.mutation({
      query: ({ id, body }) => ({
        url: `/news-pages/admin/story/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили историю', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }

        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),

    deleteStory: builder.mutation({
      query: ({ id }: { id: number }) => ({
        url: `/news-pages/admin/story/${id}`,
        method: 'DELETE',
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили историю', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }

        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const {
  useGetStoriesQuery,
  useGetStoryQuery,
  useAddStoryMutation,
  useEditStoryMutation,
  useDeleteStoryMutation,
} = useStories;
